import { GET_RULE_DASHBOARD, GET_RULE_DASHBOARD_SUCCESS, GET_RULE_DASHBOARD_ERROR, GET_RULE_DASHBOARD_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetRuleDashboard = (state = initialState, action) => {
  switch (action.type) {
    case GET_RULE_DASHBOARD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_RULE_DASHBOARD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_RULE_DASHBOARD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_RULE_DASHBOARD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetRuleDashboard;
